import React, { useState } from 'react';
import { FilterFilled } from '@ant-design/icons';
import { OrderListFilter } from '@restaurant/api';
import {
  ORDER_STATUS_OPTIONS,
  ORDER_TYPE_OPTIONS,
  PAYMENT_METHOD_OPTIONS,
} from '@restaurant/constants';
import { OrderStatus, OrderType, PaymentMethod } from '@restaurant/types';
import { sanitizeParams } from '@restaurant/utils';
import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
} from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const Filter = ({
  setValue,
}: {
  setValue: (values: OrderListFilter) => void;
}) => {
  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
    setValue({});
  };

  const onFinish = (values: {
    dateTimeOrder?: dayjs.Dayjs[];
    dateTimePayment?: dayjs.Dayjs[];
    orderNumber?: string;
    orderTypes?: OrderType[];
    statuses?: OrderStatus[];
    paymentMethods?: PaymentMethod[];
    customerName?: string;
    tableNumber?: number;
  }) => {
    const { dateTimeOrder, dateTimePayment, orderNumber, ...rest } = values;
    setValue(
      sanitizeParams({
        ...(orderNumber ? { orderNumbers: [orderNumber] } : {}),
        ...(dateTimeOrder
          ? {
              startDateTimeOrder: dateTimeOrder[0].unix(),
              endDateTimeOrder: dateTimeOrder[1].unix(),
            }
          : {}),
        ...(dateTimePayment
          ? {
              startDateTimePayment: dateTimePayment[0].unix(),
              endDateTimePayment: dateTimePayment[1].unix(),
            }
          : {}),
        ...rest,
      })
    );
  };

  return (
    <div>
      <p className="text-xl mb-4">Filter</p>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item name="dateTimeOrder" label="Date Time Order">
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item name="dateTimePayment" label="Date Time Payment">
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item label="No. Order" name="orderNumber">
          <Input placeholder="No. Order" />
        </Form.Item>
        <Form.Item label="Tipe Order" name="orderTypes">
          <Select
            options={ORDER_TYPE_OPTIONS}
            placeholder="Tipe Order"
            mode="multiple"
          />
        </Form.Item>
        <Form.Item label="Status" name="statuses">
          <Select
            options={ORDER_STATUS_OPTIONS}
            placeholder="Status"
            mode="multiple"
          />
        </Form.Item>
        <Form.Item label="Metode Bayar" name="paymentMethods">
          <Select
            options={PAYMENT_METHOD_OPTIONS}
            placeholder="Metode Bayar"
            mode="multiple"
          />
        </Form.Item>
        <Form.Item label="No Meja" name="tableNumber">
          <InputNumber placeholder="No Meja" className="w-full" />
        </Form.Item>
        <Form.Item label="Nama Customer" name="customerName">
          <Input placeholder="Nama Customer" />
        </Form.Item>
        <Button htmlType="submit" type="primary" block>
          Submit
        </Button>
        <Button onClick={onReset} block className="mt-2">
          Reset
        </Button>
      </Form>
    </div>
  );
};

export default Filter;
